import builder from '../builder';
import HourglassAlternate from '../../streamline-icons/bold/hourglass-alternate.svg';

export default builder('IconHourglassAlternateBold', HourglassAlternate);
